import { PageRoutesMap, PageSections } from "../types/routes"
import finalRoute from "./finalRoute"
import getRoute from "./getRoute"

const isListItemSelected = (section: PageSections): boolean => {
  return PageRoutesMap[section].some(
    item => item.route === finalRoute(getRoute())
  )
}

export default isListItemSelected
